import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronLeftRightFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronLeftRightFilled({
  title = 'Chevron left right',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Chevron left right'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13.6 20h3.7l5.5-8-5.5-8h-3.7l5.6 8-5.6 8ZM6.7 20h3.7l-5.6-8 5.6-8H6.7l-5.5 8 5.5 8Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ChevronLeftRightFilled;